import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { CANCELLED } from "APP_ROOT/constants";
import { QcStatusModal } from "./QcStatusModal";

export default function UpdateQcStatus({ purchaseOrder }) {
  if (purchaseOrder.get(CANCELLED)) {
    return false;
  }

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open}>
          <Icon name="pause" fixed />
          &nbsp;Update QC Status
          <QcStatusModal
            purchaseOrder={purchaseOrder}
            visible={visible}
            close={close}
          />
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

UpdateQcStatus.propTypes = {
  purchaseOrder: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/UpdateQcStatus/UpdateQcStatus.jsx